export default "__VITE_ASSET__DnQ00coY__"